import { http } from '@/libs/util'
import { util_api } from '@/libs/util_api'
const { contract_bill_generate_type } = util_api
export const getLegalAuditUsersApi = function(callBack) {
   return Util.ajax.get('contract/legal_audit_users').then((response) => {
                   return response.data;
          }).then((res) => {
              if (res.code === 1) {
               return res.data
              } else {
                  this.$Modal.error({
                      title: '错误',
                      content: res.msg,
                      onOk:callBack
                  });
                  return res
              }
          }).catch(() => {
              this.$Modal.error({
                  title: '错误',
                  content: '网络异常',
                  onOk:callBack
              });
          }); 
  }

  export function getBillGenerateTypeApi(params) {
      return http.get(contract_bill_generate_type, params)
  }